import React from 'react';
import { Search } from 'lucide-react';
import SearchBar from '../SearchBar/SearchBar';
import './SearchSection.css';

interface SearchSectionProps {
  onCartChange?: () => void;
  showNotification?: (type: 'success' | 'error' | 'info' | 'warning', title: string, message: string) => void;
  onKitchenSelect?: (kitchenId: number, kitchenName: string) => void;
}

const SearchSection: React.FC<SearchSectionProps> = ({ onCartChange, showNotification, onKitchenSelect }) => {
  return (
    <section className="search-section">
      <div className="search-section-inner">
        <div className="search-section-heading">
          <Search size={20} className="search-section-icon" />
          <h2 className="search-section-title">Find Your Next Meal</h2>
          <p className="search-section-subtitle">Search for dishes, cuisines, or kitchens near you</p>
        </div>
        <SearchBar
          onCartChange={onCartChange}
          showNotification={showNotification}
          onKitchenSelect={onKitchenSelect}
        />
      </div>
    </section>
  );
};

export default SearchSection;
